import styles from './textAreaInput.module.scss';
import { ITextAreaInputProps } from '.';
import { ReactComponent as StarIcon } from 'assets/star_required_icon.svg';
import { useFormContext } from 'react-hook-form';
import { FC } from 'react';
import { getErrorText } from 'utils/getErrorText';
import { ErrorIcon } from 'components/Core/ErorrIcon/ErrorIcon';

export const TextAreaInput: FC<ITextAreaInputProps> = ({
  name,
  label,
  placeholder,
  defaultValue,
  required = false,
  validation,
  asInput = false,
  cols,
  rows,
  showRequiredIcon = true,
  autoFocus = false,
  disabled = false,
  maxLength,
  classNameProp,
}) => {
  const formContext = useFormContext();

  const { register, getFieldState } = formContext;

  const valueAs = (val: string) => {
    if (val) return val.trim();
    return val;
  };

  return (
    <>
      {label && <p className={styles.subtitle}>{label}</p>}
      <div className={styles.areaWrap}>
        {required && showRequiredIcon && <StarIcon className={styles.requiredIcon} />}
        <textarea
          className={`${styles.textarea} ${asInput && styles.asInputTextarea} ${classNameProp}`}
          style={getFieldState(name).error ? { borderColor: '#E73331' } : {}}
          {...register(name, { required, validate: validation?.validate, setValueAs: valueAs, maxLength })}
          placeholder={placeholder}
          defaultValue={defaultValue}
          cols={cols}
          rows={rows}
          autoFocus={autoFocus}
          disabled={disabled}
        />
        {getFieldState(name).error && (
          <ErrorIcon
            name={'fullDescr'}
            message={getErrorText((getFieldState(name).error?.type as string) || '', {
              validateErrorText: validation?.message,
            })}
          />
        )}
      </div>
    </>
  );
};
